import React, { useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'

import * as types from '../../../redux/constantes/user'
import { ListRegisterAction } from '../../../redux/actions/user'

import { ContainerContentListInfo, ContainerTemplate } from '../../../components/Containers'
import { MessageBoxError } from '../../../components/MessageBox'
import { InputUser } from '../../../components/User/InputUser'
import { ButtonSend } from '../../../components/ButtonSend'
import { Header } from '../../../components/User/Header'
import { Table } from '../../../components/User/Table'
import { Card } from '../../../components/User/Card'

export const TemplateListInfos: React.FC = () => {
  const { loading, listRegisters, error } = useSelector((state: RootStateOrAny) => state.listRegister)
  const dispatch = useDispatch()

  const [accessKey, setAccessKey] = useState('')
  const [validateAccessKey, setValidateAccessKey] = useState(true)

  const accessKeyIsValid = () => {
    if (accessKey.length === 0) {
      setValidateAccessKey(false)
    } else {
      setValidateAccessKey(true)
    }
  }

  const onSubmit = () => {
    dispatch(ListRegisterAction(accessKey))
  }

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch({ type: types.LIST_REGISTER_ERROR })
      }, 5000)
    }
  }, [error])

  return (
    <ContainerTemplate>
      <Header />
      <ContainerContentListInfo>
        {!listRegisters && (
          <InputUser
            label={`Chave de Acesso ${!validateAccessKey ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
            onBlur={accessKeyIsValid}
            onChange={e => setAccessKey(e.target.value)}
            placeholder=""
            value={accessKey}
            isValidate={validateAccessKey}
          />
        )}
        {!loading ? (
          !listRegisters && <ButtonSend nameButton="Acessar" disabled={!validateAccessKey} onClick={onSubmit} />
        ) : (
          <ButtonSend nameButton="Aguarde..." disabled={true} />
        )}

        {error && <MessageBoxError>{error}</MessageBoxError>}
      </ContainerContentListInfo>
      {listRegisters && <Table usersArrays={listRegisters} />}
      {listRegisters && <Card usersArrays={listRegisters} />}
    </ContainerTemplate>
  )
}
